import { Card, Group, Image, Stack, Text, Box } from "@mantine/core";
import { Link } from "@inertiajs/react";
import type { PostSummary } from "../../types/post";
import { PostTypeBadges } from "./PostTypeBadges";
import { readingTime } from "../../lib/readingTime";

interface Props {
  post: PostSummary;
  body?: string;
}

export function PostListItem({ post, body }: Props) {
  const formatted = post.published_at
    ? new Date(post.published_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : "";

  return (
    <Link
      href={`/posts/${post.slug}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <Card
        withBorder
        radius="md"
        p="sm"
        style={{
          background: "rgba(20, 20, 28, 0.6)",
          backdropFilter: "blur(8px)",
          borderColor: "rgba(255, 128, 0, 0.12)",
        }}
      >
        <Group wrap="nowrap" align="flex-start" gap="md">
          <Box
            style={{
              width: 140,
              aspectRatio: "16/9",
              flexShrink: 0,
              borderRadius: 6,
              overflow: "hidden",
              background: "#1a1a2e",
            }}
          >
            {post.cover_image_url && (
              <Image
                src={post.cover_image_url}
                alt={post.title}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </Box>
          <Stack gap={6} style={{ flex: 1, minWidth: 0 }}>
            <PostTypeBadges
              postType={post.post_type}
              podcastNumber={post.podcast_number}
              size="xs"
            />
            <Text fw={700} lh={1.3}>
              {post.title}
            </Text>
            {post.summary && (
              <Text size="sm" c="dimmed" lineClamp={2}>
                {post.summary}
              </Text>
            )}
            <Text size="xs" c="dimmed">
              {formatted}
              {body ? ` · ${readingTime(body)} min read` : ""}
            </Text>
          </Stack>
        </Group>
      </Card>
    </Link>
  );
}

export default PostListItem;
